import {
  NavUserAvatar,
  NavUserNameTypography,
  NavUserNameWrapper,
  NavUserWrapper,
  NavUserWrapperContent,
  UserCard,
  UserCardContent,
  UserInfoSection,
  SettingsIconWrapper,
  VersionText,
  StyledMenu,
  StyledMenuItem,
  MenuItemContent,
  MenuItemIcon,
  MenuItemText,
  // MenuDivider,
  CompactUserButton,
} from './styled';
import React, { useContext } from 'react';
import { SidebarNavUserAvatarProps, SidebarNavUserProps } from '../../props';

import AuthContext from '@/auth/application/AuthContext';
import { useSidebar, usePartner } from '../../context';
import { useNavigate } from 'react-router-dom';
// import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
// import SecurityIcon from '@mui/icons-material/Security';
import { TokenOutlined } from '@mui/icons-material';
import { Link } from '@mui/material';

const getInitial = (s: string): string => {
  if (!s) return '';

  return s.charAt(0).toUpperCase();
};

const NavUser = ({ name, isSideBarOpen, onClick }: SidebarNavUserAvatarProps) => {
  const { selectedPartner, partnerData } = usePartner();

  // Use selected partner data if available, otherwise fall back to the passed name
  const currentPartner = selectedPartner && partnerData[selectedPartner];
  const displayName = currentPartner ? currentPartner.name : name;
  const displayAvatar = currentPartner ? currentPartner.avatar : getInitial(name as string);

  return (
    <UserCard isSideBarOpen={isSideBarOpen} sx={{ p: '2px 6px' }} onClick={onClick}>
      <UserCardContent>
        <UserInfoSection>
          <NavUserAvatar variant="rounded">{displayAvatar}</NavUserAvatar>
          <NavUserNameWrapper>
            <NavUserNameTypography>{displayName}</NavUserNameTypography>
          </NavUserNameWrapper>
        </UserInfoSection>
        <SettingsIconWrapper>
          <TokenOutlined />
        </SettingsIconWrapper>
      </UserCardContent>
    </UserCard>
  );
};

const CompactUser = ({ name }: { name: string }) => {
  const { selectedPartner, partnerData } = usePartner();

  // Use selected partner data if available, otherwise fall back to the passed name
  const currentPartner = selectedPartner && partnerData[selectedPartner];
  const displayAvatar = currentPartner ? currentPartner.avatar : getInitial(name as string);

  return (
    <CompactUserButton>
      <NavUserAvatar variant="rounded">{displayAvatar}</NavUserAvatar>
    </CompactUserButton>
  );
};

const SidebarNavUser: React.FC<SidebarNavUserProps> = ({ name, forceIsSideBarOpen }: SidebarNavUserProps) => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  const { isSideBarOpen } = useSidebar();
  const sidebarOpen = forceIsSideBarOpen ?? isSideBarOpen;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleClose();
    if (authContext) {
      await authContext.logout();
    }
    navigate('/login');
  };

  const handleProfile = () => {
    handleClose();
    navigate('/home/profile');
  };

  // const handleSettings = () => {
  //   handleClose();
  // };

  return (
    <>
      <NavUserWrapper isSideBarOpen={sidebarOpen} id="sidenav-user-button" aria-haspopup="true" sx={{ width: '100%', marginTop: 'auto' }}>
        <NavUserWrapperContent isSideBarOpen={sidebarOpen}>
          {sidebarOpen ? (
            <>
              <NavUser name={name} isSideBarOpen={sidebarOpen} onClick={handleClick} />

              <VersionText>{import.meta.env.VITE_APP_VERSION || '0.0.1'}</VersionText>
              <Link href="https://www.rapidworks.com/" underline="none" variant="body2" sx={{ color: '#fff', textAlign: 'center' }}>
                Powered by RapidWorks
              </Link>
            </>
          ) : (
            <CompactUser name={name} />
          )}
        </NavUserWrapperContent>
      </NavUserWrapper>
      <StyledMenu
        id="sidenav-user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'sidenav-user-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        elevation={8}
      >
        <StyledMenuItem onClick={handleProfile}>
          <MenuItemContent>
            <MenuItemIcon>
              <PersonIcon />
            </MenuItemIcon>
            <MenuItemText>
              <div>
                <div style={{ fontWeight: 600, fontSize: '0.875rem' }}>Profile</div>
                <div style={{ fontSize: '0.75rem', opacity: 0.7 }}>View your profile</div>
              </div>
            </MenuItemText>
          </MenuItemContent>
        </StyledMenuItem>

        {/*       <StyledMenuItem onClick={handleSettings}>
          <MenuItemContent>
            <MenuItemIcon>
              <SettingsIcon />
            </MenuItemIcon>
            <MenuItemText>
              <div>
                <div style={{ fontWeight: 600, fontSize: '0.875rem' }}>Settings</div>
                <div style={{ fontSize: '0.75rem', opacity: 0.7 }}>Manage your preferences</div>
              </div>
            </MenuItemText>
          </MenuItemContent>
        </StyledMenuItem>

        <StyledMenuItem onClick={handleClose}>
          <MenuItemContent>
            <MenuItemIcon>
              <SecurityIcon />
            </MenuItemIcon>
            <MenuItemText>
              <div>
                <div style={{ fontWeight: 600, fontSize: '0.875rem' }}>Security</div>
                <div style={{ fontSize: '0.75rem', opacity: 0.7 }}>Account security settings</div>
              </div>
            </MenuItemText>
          </MenuItemContent>
        </StyledMenuItem>

        <MenuDivider /> */}

        <StyledMenuItem onClick={handleLogout} sx={{ color: '#d32f2f' }}>
          <MenuItemContent>
            <MenuItemIcon sx={{ color: '#d32f2f' }}>
              <LogoutIcon />
            </MenuItemIcon>
            <MenuItemText>
              <div>
                <div style={{ fontWeight: 600, fontSize: '0.875rem' }}>Sign Out</div>
                <div style={{ fontSize: '0.75rem', opacity: 0.7 }}>Logout from your account</div>
              </div>
            </MenuItemText>
          </MenuItemContent>
        </StyledMenuItem>
      </StyledMenu>
    </>
  );
};

export default SidebarNavUser;
